import defaultLogo from "../../images/scope-white.svg"



const GameTopBar = ({ logo }: { logo: string | null }) => {
    const useLogo = logo ?? defaultLogo;

    return (
        <div className='game-top-bar'>
            <div className='game-top-bar-content'>
                <img className='game-logo' src={useLogo} alt='Game logo'/>
            </div>
        </div>
    );
}

export default GameTopBar;